export const skills = [
    {
        id: 0,
        name: 'Bootstrap',
        level: 'Intermedio',
        image: 'bootstrap-logo'
    },
    {
        id: 1,
        name: 'CSS',
        level: 'Básico',
        image: 'css-logo'
    },
    {
        id: 2,
        name: 'HTML',
        level: 'Intermedio',
        image: 'html-logo'
    },
    {
        id: 3,
        name: 'ReactJS',
        level: 'Básico',
        image: 'react-logo'
    },
    {
        id: 4,
        name: 'Javascript',
        level: 'Básico',
        image: 'javascript-logo'
    },
    {
        id: 5,
        name: 'Tailwind CSS',
        level: 'Básico',
        image: 'tailwindcss-logo'
    },
    {
        id: 6,
        name: 'VueJS',
        level: 'Básico',
        image: 'vue-logo'
    },
]